import React from 'react';
import { Col } from 'reactstrap';

function CustomDashboardEditPanelRow({ children, classSufix, className = '' }) {
  const getColSize = (index) => {
    const sizeMultipByIndex = {
      0: 5,
      1: 5,
      3: 2,
    };
    const colSizes = {
      xs: sizeMultipByIndex[index],
      sm: sizeMultipByIndex[index],
      md: sizeMultipByIndex[index],
      lg: sizeMultipByIndex[index],
      xl: sizeMultipByIndex[index],
    };
    return colSizes;
  };
  return (
    <div style={{ padding: '0px 0px 5px', width: '100%' }}>
      <div className={`custom-dashboard-panel-row-edit-wrapper ${className}`}>
        {children.map((child, index) => (
          <Col
            key={`child-${index}`}
            className={`custom-dashboard-panel-row-edit-col-${classSufix}`}
            {...getColSize(index)}
          >
            {child}
          </Col>
        ))}
      </div>
    </div>
  );
}


export default CustomDashboardEditPanelRow;
